module.exports = __webpack_public_path__ + "static/UK-fe766b72a532ac29238fe2f29f7d05b8.png";